import React from 'react';
import classNames from 'classnames';
import { InputBaseProps } from '../../../interfaces/interfaces';

interface TextInputProps extends InputBaseProps {
	label?: string,
	invalid?: boolean,
	invalidMessage?: string,
}

const TextInput = ({ id, label, invalid, invalidMessage, className, placeholder, value, onBlur, onInput, onChange }: TextInputProps) => {


	return (
		<div className="col px-0">
			<label htmlFor={id} className="mb-0">
				{label}
			</label>
			<div className="cc-input-group w-100">
				<input
					id={id}
					inputMode='text'
					className={classNames(invalid && 'cc-input-field--invalid', className && className)}
					placeholder={placeholder}
					value={value}
					onBlur={onBlur}
					onInput={onInput}
					onChange={event => onChange(event.currentTarget.value)}
				/>
			</div>
			{invalid && invalidMessage && (
				<div className="invalid-error-message--input-field">{invalidMessage}</div>
			)}
		</div>
	);
};

export default TextInput;